import React from 'react';
import { Toaster as ReactToaster } from 'react-hot-toast';

const Toaster = () => {
  return (
    <ReactToaster
      toastOptions={{
        // Define default options
        className: '',
        duration: 100000,
        style: {
          background: '#363636',
          color: '#fff',
        },

        // Default options for specific types
        success: {
          duration: 5000,
          style: {
            background: '#2dac70',
            color: '#fff',
            borderRadius: '0',
          },
          className: 'text-sm font-light text-white',
          icon: <i className="icon icon-check relative text-24 !font-light"></i>,
        },
        error: {
          duration: 5000,
          style: {
            background: '#dc143c',
            color: '#fff',
            borderRadius: '0',
          },
          className: 'text-sm font-light text-white',
          icon: <i className="icon icon-pricematch relative text-24 !font-light"></i>,
        },
      }}
    />
  );
};

export default Toaster;
